import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { formatNumber } from "@/lib/formatters";
import { cn } from "@/lib/utils";

export interface RouteTab {
  key: string;
  label: ReactNode;
  to: string;
  /** A count beside the label; hidden while unknown (null / undefined). */
  count?: number | null;
}

/** The app's underline tabs, each one a real link: the URL is the state. */
export function RouteTabs({
  value,
  tabs,
  className,
  label,
}: {
  value: string;
  tabs: RouteTab[];
  className?: string;
  label: string;
}) {
  return (
    <Tabs value={value}>
      <TabsList aria-label={label} className={cn("no-scrollbar", className)}>
        {tabs.map((tab) => (
          <TabsTrigger key={tab.key} value={tab.key} asChild>
            <Link to={tab.to} replace={false}>
              {tab.label}
              {tab.count !== undefined && tab.count !== null && (
                <span
                  className={cn(
                    "ml-1.5 rounded-full px-1.5 py-px text-[11px] font-semibold tabular-nums",
                    tab.key === value ? "bg-indigo-50 text-indigo-600" : "bg-slate-100 text-slate-500",
                  )}
                >
                  {formatNumber(tab.count)}
                </span>
              )}
            </Link>
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
